var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ShowButton, CloneButton, EditActions as RaEditActions, TopToolbar, usePermissions, useResourceContext, useResourceDefinition, useEditContext, } from 'react-admin';
import { canAccess } from '../canAccess';
/**
 * Replacement for react-admin's EditAction that adds RBAC control to actions
 *
 * Users must have the 'show' permission on the resource and record to see the ShowButton.
 * Users must have the 'clone' permission on the resource and record to see the CloneButton.
 *
 * @example
 * import { Edit } from 'react-admin';
 * import { EditActions } from '@react-admin/ra-rbac';
 *
 * export const PostEdit = () => (
 *     <Edit actions={<EditActions />}>
 *         ...
 *     </Edit>
 * );
 */
export var EditActions = function (props) {
    var className = props.className;
    var _a = useEditContext(props), record = _a.record, rest = __rest(_a, ["record"]);
    var hasShow = useResourceDefinition(props).hasShow;
    var resource = useResourceContext(props);
    var _b = usePermissions(), isLoading = _b.isLoading, permissions = _b.permissions;
    if (isLoading) {
        return null;
    }
    var canShow = hasShow &&
        canAccess({
            permissions: permissions,
            action: 'show',
            resource: resource,
            record: record,
        });
    var canClone = canAccess({
        permissions: permissions,
        action: 'clone',
        resource: resource,
        record: record,
    });
    if (!canShow && !canClone) {
        return React.createElement("div", { style: { marginTop: '1em' } });
    }
    return (React.createElement(TopToolbar, __assign({ className: className }, sanitizeRestProps(rest)),
        canShow && React.createElement(ShowButton, null),
        canClone && React.createElement(CloneButton, null)));
};
EditActions.propTypes = RaEditActions.propTypes;
var sanitizeRestProps = function (_a) {
    var basePath = _a.basePath, defaultTitle = _a.defaultTitle, className = _a.className, hasCreate = _a.hasCreate, hasList = _a.hasList, hasEdit = _a.hasEdit, loaded = _a.loaded, loading = _a.loading, refetch = _a.refetch, resource = _a.resource, rest = __rest(_a, ["basePath", "defaultTitle", "className", "hasCreate", "hasList", "hasEdit", "loaded", "loading", "refetch", "resource"]);
    return rest;
};
